export const NO_ADU_SELECTED_MESSAGE = "";
export const ADU_PLACEMENT_FEASIBLE = "ADU placement feasible";
